import UploadFile from "./UploadFile.vue";
export default UploadFile;